import type { User } from "@fitties/shared";
export function hasUnlockedEvent(user: User, eventId: string | null | undefined): boolean {
  if (!eventId) {
    return false;
  }
  return (user.unlockedEventIds ?? []).includes(eventId);
}

/** Discovery, matches, and chat are not time-gated; always available. */
export function hasCurrentEventFullAccess(_user: User, _now: Date = new Date()): boolean {
  return true;
}

export function isPaidForCurrentEvent(user: User): boolean {
  return hasUnlockedEvent(user, user.lastKnownEventId);
}

export interface AccessPolicy {
  canUseDiscovery: boolean;
  canSeeLikedYou: boolean;
  canSeeMatches: boolean;
  canOpenChat: boolean;
  canSendMessage: boolean;
  /** Always false — time-based discovery paywall retired. */
  requiresPaymentWall: boolean;
}

/** Liked you requires event unlock; event presence alone does not unlock it. */
export function canAccessLikedYou(viewer: User): boolean {
  if (!viewer.lastKnownEventId) {
    return true;
  }
  return hasUnlockedEvent(viewer, viewer.lastKnownEventId);
}

/** VIP liked-you modal: on event and unpaid for liked-you. */
export function shouldShowVipLikedYouPaywall(viewer: User, _now: Date = new Date()): boolean {
  if (!viewer.lastKnownEventId) {
    return false;
  }
  if (hasUnlockedEvent(viewer, viewer.lastKnownEventId)) {
    return false;
  }
  return !canAccessLikedYou(viewer);
}

export function getAccessPolicy(viewer: User, _otherUser?: User | null, _now: Date = new Date()): AccessPolicy {
  const likedYouUnlocked = canAccessLikedYou(viewer);

  return {
    canUseDiscovery: true,
    canSeeLikedYou: likedYouUnlocked,
    canSeeMatches: true,
    canOpenChat: true,
    canSendMessage: true,
    requiresPaymentWall: false,
  };
}
